import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度专题报道 · 一站式吃瓜解读</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselData.map((item) => (
            <button
              key={item.id}
              onClick={() => handleScroll('#cards')}
              className="group flex flex-col bg-background-100 rounded-2xl overflow-hidden border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer text-left"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    const parent = target.parentElement;
                    target.style.display = 'none';
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.badge}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl text-foreground-800 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1 mt-4 text-xs text-primary-500 font-medium">
                  <span>浏览专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}